<template>
  <div>
    <v-container grid-list-xl>
      <v-layout wrap>
        <v-flex
          class="default-input-textfield form-control"
          xs12
          :class="{ 'has-error': errors.has('reportType') }"
        >
          <div class="body-1 mb-1">Type of report <span class="red--text">*</span></div>
          <v-select
            v-model="selectedType"
            v-validate="'required'"
            class="default-input-textfield"
            :items="typeOptions"
            item-text="label"
            item-value="value"
            label="Select"
            persistent-hint
            return-object
            outline
            hide-details
            single-line
            name="reportType"
            :data-vv-as="'Type of report'"
            placeholder="Select type of report"
            style="max-width: 50%"
          ></v-select>
          <span v-if="errors.has('reportType')" class="text-error">{{
            errors.first('reportType')
          }}</span>
        </v-flex>

        <v-flex v-if="!['close_cased_by_webpage'].includes(selectedType.value)" xs12>
          <div class="body-1 mb-1">Select Page</div>
          <v-radio-group v-model="selectedPage" hide-details row>
            <v-radio
              v-for="option in pageOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12>
          <div class="body-1 mb-1">Select Channel</div>
          <v-radio-group v-model="selectedChannel" hide-details row>
            <v-radio
              v-for="option in channelOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex v-if="isShowChatType" xs12>
          <div class="body-1 mb-1">Select Type</div>
          <v-radio-group v-model="selectedChatType" hide-details row>
            <v-radio
              v-for="option in filterChatTypeOptions"
              :key="option.value"
              :label="option.text"
              :value="option.value"
            ></v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex
          v-if="
            selectedType &&
            ['sl_by_agent_by_interval', 'transection_by_agent'].includes(selectedType.value) &&
            selectedChatType === 'agent'
          "
          class="default-input-textfield form-control"
          xs12
        >
          <div class="body-1 mb-1">Select Agent</div>
          <v-select
            v-model="selectedAgent"
            class="default-input-textfield"
            :items="agentOptions"
            persistent-hint
            outline
            hide-details
            single-line
            name="agents"
            placeholder="Select Agent"
            style="max-width: 50%"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <div class="body-1 mb-1">Select Date</div>
          <DateFilter
            ref="dateFilter"
            v-model="selectedDate"
            :default-filter="selectedDate.filter"
            :hide-search="true"
          />
        </v-flex>

        <v-flex d-flex xs12>
          <v-layout>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-btn color="primary" large @click="handleExportExcel">
                <v-icon>logout</v-icon>
                Export
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DATETIME } from '@/constants/datetime'
import { TTB_CHANNEL_LIST } from '@/constants/ttb'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ttbApi from '@/api/ttb'
import dayjs from 'dayjs'
import XLSX from 'xlsx'
import get from 'lodash/get'

export default {
  name: 'ExportReport',
  components: {
    DateFilter
  },
  data() {
    return {
      selectedType: '',
      selectedPage: 'all',
      selectedChannel: 'all',
      selectedChatType: 'all',
      selectedAgent: '',
      selectedDate: {
        filter: 'last_7_days',
        start: dayjs().subtract(7, 'days').format(DATETIME.DATE_FORMAT),
        end: dayjs().format(DATETIME.DATE_FORMAT)
      },

      typeOptions: [
        { label: 'Overview report', value: 'overview' },
        { label: 'Productivity report', value: 'productivity' },
        { label: 'Performance Non-voice report', value: 'performance_non_voice' },
        { label: 'SL by agent by interval report', value: 'sl_by_agent_by_interval' },
        { label: 'Productivity by interval report', value: 'productivity_by_interval' },
        { label: 'Summary staff performance report', value: 'summary_staff_performance' },
        { label: 'Close cased by channel', value: 'close_cased_by_channel' },
        { label: 'Cased by status', value: 'cased_by_status' },
        { label: 'Cased by products', value: 'cased_by_products' },
        // { label: 'Close cased by wrap up', value: 'close_cased_by_wrap_up' },
        { label: 'Close cased by webpage', value: 'close_cased_by_webpage' }
        // { label: 'Survey Report', value: 'survey' }
        // { label: 'Transection by agent', value: 'transection_by_agent' }
      ],
      pageOptions: [
        { value: 'all', text: 'All' },
        ...this.$store.state.botlist.map((item) => ({ value: item.pageid, text: item.pagename }))
      ],
      channelOptions: [{ value: 'all', text: 'All' }, ...TTB_CHANNEL_LIST],
      chatTypeOptions: [
        { value: 'all', text: 'All' },
        { value: 'agent', text: 'Agent' },
        { value: 'bot', text: 'Bot' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    agentList() {
      return this.$store.state.agents
    },
    agentOptions() {
      return this.agentList.map((el) => el.adminid)
    },
    isShowChatType() {
      return (
        this.selectedType &&
        [
          'productivity',
          'productivity_by_interval',
          'sl_by_agent_by_interval',
          'transection_by_agent'
        ].includes(this.selectedType.value)
      )
    },
    filterChatTypeOptions() {
      const type = this.selectedType && this.selectedType.value
      let options = []

      if (
        type &&
        (type === 'summary_staff_performance' ||
          type === 'sl_by_agent_by_interval' ||
          type === 'transection_by_agent')
      ) {
        options = this.chatTypeOptions.filter((item) => item.value !== 'bot')
      } else {
        options = this.chatTypeOptions
      }

      return options
    }
  },
  mounted() {
    if (this.agentList.length === 0) {
      this.$store.dispatch('loadAgents')
    }
  },
  methods: {
    async handleExportExcel() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        const type = vm.selectedType.value
        const payload = {
          page_id: vm.selectedBot.pageid,
          select_page_id: vm.selectedPage,
          channel: vm.selectedChannel,
          date_from: dayjs(vm.selectedDate.start).format(DATETIME.DATE_FORMAT),
          date_to: dayjs(vm.selectedDate.end).format(DATETIME.DATE_FORMAT),
          ...([
            'productivity',
            'productivity_by_interval',
            'summary_staff_performance',
            'sl_by_agent_by_interval',
            'transection_by_agent'
          ].includes(type) && {
            select_type: vm.selectedChatType
          }),
          ...([
            'summary_staff_performance',
            'sl_by_agent_by_interval',
            'transection_by_agent'
          ].includes(type) &&
            vm.selectedChatType !== 'all' && {
              agent: vm.selectedAgent,
              admin_id: vm.selectedAgent
            })
        }

        vm.$store.dispatch('loading')
        const response = await vm.getReportByType(type, payload)

        if (response && response.status === 200) {
          const responseData = response.data

          switch (type) {
            case 'overview':
              vm.exportOverviewReport(responseData)
              break
            case 'productivity':
              vm.exportProductivityReport(responseData)
              break
            case 'performance_non_voice':
              vm.exportPerformanceNonvoiceReport(responseData)
              break
            case 'sl_by_agent_by_interval':
              vm.exportSlByAgentByIntervalReport(responseData)
              break
            case 'productivity_by_interval':
              vm.exportProductivityByIntervalReport(responseData)
              break
            case 'summary_staff_performance':
              vm.exportSummaryStaffPerformanceReport(responseData, payload)
              break
            case 'close_cased_by_channel':
              vm.exportClosedCaseByChannelReport(responseData)
              break
            case 'cased_by_status':
              vm.exportCaseByStatusReport(responseData)
              break
            case 'cased_by_products':
              vm.exportCaseByProductReport(responseData)
              break
            case 'close_cased_by_wrap_up':
              vm.exportClosedCaseByWrapUpReport(responseData)
              break
            case 'close_cased_by_webpage':
              vm.exportClosedCaseByWebpageReport(responseData)
              break
            case 'survey':
              vm.exportSurveyReport(responseData)
              break
            case 'transection_by_agent':
              vm.exportTransectionByAgentReport(responseData, payload)
              break
            default:
              break
          }
        }
        vm.$store.commit('CLEAR_LOADING')
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async getReportByType(type, payload) {
      try {
        let data = null

        switch (type) {
          case 'overview':
            data = await ttbApi.getReportOverview({
              params: payload
            })
            break
          case 'productivity':
            data = await ttbApi.getReportProductivity({
              params: payload
            })
            break
          case 'performance_non_voice':
            data = await ttbApi.getReportPerformanceNonvoice({
              params: payload
            })
            break
          case 'sl_by_agent_by_interval':
            data = await ttbApi.getReportSlByAgentInterval({
              params: payload
            })
            break
          case 'productivity_by_interval':
            data = await ttbApi.getReportProductivityInterval({
              params: payload
            })
            break
          case 'summary_staff_performance':
            data = await ttbApi.getReportSummaryStaffPerformanceByAgent({
              params: payload
            })
            break
          case 'close_cased_by_channel':
            data = await ttbApi.getReportCloseCaseByChannel({
              params: payload
            })
            break
          case 'cased_by_status':
            data = await ttbApi.getReportCaseByStatus({
              params: payload
            })
            break
          case 'cased_by_products':
            data = await ttbApi.getReportCaseByProduct({
              params: payload
            })
            break
          case 'close_cased_by_wrap_up':
            data = await ttbApi.getReportCloseCaseByWrapUp({
              params: payload
            })
            break
          case 'close_cased_by_webpage':
            data = await ttbApi.getReportCloseCaseByWebPage({
              params: { ...payload, select_page_id: 'all' }
            })
            break
          case 'survey':
            data = await ttbApi.getReportSurvey({
              params: payload
            })
            break
          case 'transection_by_agent':
            data = await ttbApi.getReportTransectionByAgent({
              params: payload
            })
            break
          default:
            data = null
            break
        }

        return data
      } catch (error) {
        console.error(error)
        return null
      }
    },
    async exportOverviewReport(data) {
      try {
        if (data === null || data.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        const allPageData = data.all_page_data
        const channelData = data.channel_data
        const pageData = data.page_data

        delete channelData.line

        // Start: Calculate Largest remainder method
        // Start: Channel
        // Answer
        let answerdChannelPercentages = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.answered_percent)
        )
        let answerdChannelAdjustedPercentages = this.distributeRounding(
          answerdChannelPercentages,
          100
        )

        // Cancelled by customer
        let cancelledByCustomerChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.cancelled_by_customer_percent)
        )
        let cancelledByCustomerChannelAdjustedPercentages = this.distributeRounding(
          cancelledByCustomerChannelPercent,
          100
        )

        // Closed by system
        let closedBySystemChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.closed_by_system_percent)
        )
        let closedBySystemChannelAdjustedPercentages = this.distributeRounding(
          closedBySystemChannelPercent,
          100
        )

        // Closed with survey
        let closeWithSurveyChannelPercentages = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.closed_with_survey_percent)
        )
        let closeWithSurveyChannelAdjustedPercentages = this.distributeRounding(
          closeWithSurveyChannelPercentages,
          100
        )

        // Closed without survey
        let closeWithoutSurveyChannelPercentages = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.closed_without_survey_percent)
        )
        let closeWithoutSurveyChannelAdjustedPercentages = this.distributeRounding(
          closeWithoutSurveyChannelPercentages,
          100
        )

        // Pending
        let pendingChannelPercentages = Object.values(channelData).map((platform) =>
          parseFloat(platform.status.pending_percent)
        )
        let pendingChannelAdjustedPercentages = this.distributeRounding(
          pendingChannelPercentages,
          100
        )

        let averageFirstResponseTimeChannelPercentages = Object.values(channelData).map(
          (platform) => parseFloat(platform.average_first_response_time_percent)
        )
        let averageFirstResponseTimeChannelAdjustedPercentages = this.distributeRounding(
          averageFirstResponseTimeChannelPercentages,
          100
        )

        let averageResolvedTimeChannelPercentages = Object.values(channelData).map((platform) =>
          parseFloat(platform.average_resolved_time_percent)
        )

        let averageResolvedTimeChannelAdjustedPercentages = this.distributeRounding(
          averageResolvedTimeChannelPercentages,
          100
        )

        let numberOfCaseByAgentChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.number_of_case_by_agent_percent)
        )

        let numberOfCaseByAgentChannelAdjustedPercentages = this.distributeRounding(
          numberOfCaseByAgentChannelPercent,
          100
        )

        let numberOfCaseByBotChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.number_of_case_by_bot_percent)
        )

        let numberOfCaseByBotChannelAdjustedPercentages = this.distributeRounding(
          numberOfCaseByBotChannelPercent,
          100
        )

        let receivedChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.received_percent)
        )

        let receivedChannelAdjustedPercentages = this.distributeRounding(
          receivedChannelPercent,
          100
        )

        let resolvedChannelPercent = Object.values(channelData).map((platform) =>
          parseFloat(platform.resolved_percent)
        )

        let resolvedChannelAdjustedPercentages = this.distributeRounding(
          resolvedChannelPercent,
          100
        )

        Object.keys(channelData).forEach((key, index) => {
          channelData[key].status.answered_percent = answerdChannelAdjustedPercentages[index]
          channelData[key].status.cancelled_by_customer_percent =
            cancelledByCustomerChannelAdjustedPercentages[index]
          channelData[key].status.closed_by_system_percent =
            closedBySystemChannelAdjustedPercentages[index]
          channelData[key].status.closed_with_survey_percent =
            closeWithSurveyChannelAdjustedPercentages[index]
          channelData[key].status.closed_without_survey_percent =
            closeWithoutSurveyChannelAdjustedPercentages[index]
          channelData[key].status.pending_percent = pendingChannelAdjustedPercentages[index]
          channelData[key].average_first_response_time_percent =
            averageFirstResponseTimeChannelAdjustedPercentages[index]
          channelData[key].average_resolved_time_percent =
            averageResolvedTimeChannelAdjustedPercentages[index]
          channelData[key].number_of_case_by_agent_percent =
            numberOfCaseByAgentChannelAdjustedPercentages[index]
          channelData[key].number_of_case_by_bot_percent =
            numberOfCaseByBotChannelAdjustedPercentages[index]
          channelData[key].received_percent = receivedChannelAdjustedPercentages[index]
          channelData[key].resolved_percent = resolvedChannelAdjustedPercentages[index]
        })
        // End: Channel

        // Start: Page
        // Answer
        let answerdPagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.answered_percent)
        )
        let answerdPageAdjustedPercentages = this.distributeRounding(answerdPagePercentages, 100)

        // Cancelled by customer
        let cancelledByCustomerPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.cancelled_by_customer_percent)
        )
        let cancelledByCustomerPageAdjustedPercentages = this.distributeRounding(
          cancelledByCustomerPagePercent,
          100
        )

        // Closed by system
        let closedBySystemPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.closed_by_system_percent)
        )
        let closedBySystemPageAdjustedPercentages = this.distributeRounding(
          closedBySystemPagePercent,
          100
        )

        // Closed with survey
        let closeWithSurveyPagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.closed_with_survey_percent)
        )
        let closeWithSurveyPageAdjustedPercentages = this.distributeRounding(
          closeWithSurveyPagePercentages,
          100
        )

        // Closed without survey
        let closeWithoutSurveyPagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.closed_without_survey_percent)
        )
        let closeWithoutSurveyPageAdjustedPercentages = this.distributeRounding(
          closeWithoutSurveyPagePercentages,
          100
        )

        // Pending
        let pendingPagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.status.pending_percent)
        )
        let pendingPageAdjustedPercentages = this.distributeRounding(pendingPagePercentages, 100)

        let averageFirstResponseTimePagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.average_first_response_time_percent)
        )
        let averageFirstResponseTimePageAdjustedPercentages = this.distributeRounding(
          averageFirstResponseTimePagePercentages,
          100
        )

        let averageResolvedTimePagePercentages = Object.values(pageData).map((platform) =>
          parseFloat(platform.average_resolved_time_percent)
        )

        let averageResolvedTimePageAdjustedPercentages = this.distributeRounding(
          averageResolvedTimePagePercentages,
          100
        )

        let numberOfCaseByAgentPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.number_of_case_by_agent_percent)
        )

        let numberOfCaseByAgentPageAdjustedPercentages = this.distributeRounding(
          numberOfCaseByAgentPagePercent,
          100
        )

        let numberOfCaseByBotPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.number_of_case_by_bot_percent)
        )

        let numberOfCaseByBotPageAdjustedPercentages = this.distributeRounding(
          numberOfCaseByBotPagePercent,
          100
        )

        let receivedPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.received_percent)
        )

        let receivedPageAdjustedPercentages = this.distributeRounding(receivedPagePercent, 100)

        let resolvedPagePercent = Object.values(pageData).map((platform) =>
          parseFloat(platform.resolved_percent)
        )

        let resolvedPageAdjustedPercentages = this.distributeRounding(resolvedPagePercent, 100)

        Object.keys(pageData).forEach((key, index) => {
          pageData[key].status.answered_percent = answerdPageAdjustedPercentages[index]
          pageData[key].status.cancelled_by_customer_percent =
            cancelledByCustomerPageAdjustedPercentages[index]
          pageData[key].status.closed_by_system_percent =
            closedBySystemPageAdjustedPercentages[index]
          pageData[key].status.closed_with_survey_percent =
            closeWithSurveyPageAdjustedPercentages[index]
          pageData[key].status.closed_without_survey_percent =
            closeWithoutSurveyPageAdjustedPercentages[index]
          pageData[key].status.pending_percent = pendingPageAdjustedPercentages[index]
          pageData[key].average_first_response_time_percent =
            averageFirstResponseTimePageAdjustedPercentages[index]
          pageData[key].average_resolved_time_percent =
            averageResolvedTimePageAdjustedPercentages[index]
          pageData[key].number_of_case_by_agent_percent =
            numberOfCaseByAgentPageAdjustedPercentages[index]
          pageData[key].number_of_case_by_bot_percent =
            numberOfCaseByBotPageAdjustedPercentages[index]
          pageData[key].received_percent = receivedPageAdjustedPercentages[index]
          pageData[key].resolved_percent = resolvedPageAdjustedPercentages[index]
        })
        // End: Page

        // End: Calculate Largest remainder method

        const json = []

        json.push(['Overview'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATETIME_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATETIME_FORMAT_DISPLAY)}`
        ])

        json.push(['Status', 'Page', 'Channel'])

        const {
          row: secondHeaderRow,
          pageCellRange,
          channelCellRange
        } = (() => {
          const pageColumns = (() => {
            if (this.selectedPage !== 'all') {
              return Object.entries(pageData)
                .filter(([pageKey]) => pageKey.split('_')[0] === this.selectedPage)
                .map(([, page]) => page.page_name)
            }
            return [
              'All',
              ...Object.values(pageData)
                .map((page) => [page.page_name, 'Percentage'])
                .flat()
            ]
          })()
          const channelColumns = (() => {
            if (this.selectedChannel !== 'all') {
              return Object.keys(channelData)
                .filter((key) => key === this.selectedChannel)
                .map((key) => [key, 'Percentage'])
                .flat()
            }
            return [
              'All',
              ...Object.keys(channelData)
                .map((key) => [key, 'Percentage'])
                .flat()
            ]
          })()

          return {
            row: ['', ...pageColumns, ...channelColumns],
            pageCellRange: {
              s: { r: 2, c: 1 },
              e: { r: 2, c: 1 + pageColumns.length - 1 }
            },
            channelCellRange: {
              s: { r: 2, c: 1 + pageColumns.length },
              e: { r: 2, c: 1 + pageColumns.length + channelColumns.length - 1 }
            }
          }
        })()

        json.push(secondHeaderRow)

        json[2] = [
          'Status',
          ...Array(pageCellRange.e.c - pageCellRange.s.c + 1)
            .fill('')
            .map((value, index) => {
              if (index === 0) return 'Page'
              return value
            }),
          ...Array(channelCellRange.e.c - channelCellRange.s.c + 1)
            .fill('')
            .map((value, index) => {
              if (index === 0) return 'Channel'
              return value
            })
        ]

        const statuses = [
          {
            text: 'Pending',
            valueKey: 'status.pending',
            percentKey: 'status.pending_percent'
          },
          {
            text: 'Answered',
            valueKey: 'status.answered',
            percentKey: 'status.answered_percent'
          },
          {
            text: 'Closed with survey',
            valueKey: 'status.closed_with_survey',
            percentKey: 'status.closed_with_survey_percent'
          },
          {
            text: 'Closed without survey',
            valueKey: 'status.closed_without_survey',
            percentKey: 'status.closed_without_survey_percent'
          },
          {
            text: 'Closed by SLA',
            valueKey: 'status.closed_by_system',
            percentKey: 'status.closed_by_system_percent'
          },
          {
            text: 'Number of case by agent',
            valueKey: 'number_of_case_by_agent',
            percentKey: 'number_of_case_by_agent_percent'
          },
          {
            text: 'Number of case by bot',
            valueKey: 'number_of_case_by_bot',
            percentKey: 'number_of_case_by_bot_percent'
          },
          {
            text: 'Received',
            valueKey: 'received',
            percentKey: 'received_percent'
          },
          {
            text: 'Resolved',
            valueKey: 'resolved',
            percentKey: 'resolved_percent'
          },
          {
            text: 'Average first response time',
            valueKey: 'average_first_response_time',
            percentKey: 'average_first_response_time_percent'
          },
          {
            text: 'Average first resolved time',
            valueKey: 'average_resolved_time',
            percentKey: 'average_resolved_time_percent'
          }
        ]

        statuses.forEach(({ text, valueKey, percentKey }) => {
          const pageColumns = (() => {
            if (this.selectedPage !== 'all') {
              return Object.entries(pageData)
                .filter(([pageKey]) => pageKey.split('_')[0] === this.selectedPage)
                .map(([, page]) =>
                  ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                    ? this.transformDurationTime(get(page, valueKey))
                    : get(page, valueKey)
                )
            }
            return [
              ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                ? this.transformDurationTime(get(allPageData, valueKey))
                : get(allPageData, valueKey),
              ...Object.values(pageData)
                .map((page) => [
                  ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                    ? this.transformDurationTime(get(page, valueKey))
                    : get(page, valueKey),
                  `${Math.round(get(page, percentKey))}%`
                ])
                .flat()
            ]
          })()
          const channelColumns = (() => {
            if (this.selectedChannel !== 'all') {
              return Object.entries(channelData)
                .filter(([channelKey]) => channelKey === this.selectedChannel)
                .map(([, channel]) => {
                  return [
                    ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                      ? this.transformDurationTime(get(channel, valueKey))
                      : `${Math.round(get(channel, percentKey))}%`
                  ]
                })
                .flat()
            }
            return [
              ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                ? this.transformDurationTime(get(allPageData, valueKey))
                : get(allPageData, valueKey),
              ...Object.values(channelData)
                .map((channel) => [
                  ['average_first_response_time', 'average_resolved_time'].includes(valueKey)
                    ? this.transformDurationTime(get(channel, valueKey))
                    : get(channel, valueKey),
                  `${Math.round(get(channel, percentKey))}%`
                ])
                .flat()
            ]
          })()
          json.push([text, ...pageColumns, ...channelColumns])
        })

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 2, c: 0 },
              e: { r: 3, c: 0 }
            },
            pageCellRange,
            channelCellRange
          ])
          .save('report-overview')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportProductivityReport(data) {
      try {
        if (data === null || data.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        const inboxAgentData = data.inbox_agent_data
        const inboxBotData = data.inbox_bot_data
        const totalCaseBotData = data.total_case_bot_data
        const totalCaseAgentData = data.total_case_agent_data
        const wallPostBotData = data.wall_post_bot_data
        const wallPostAgentData = data.wall_post_agent_data
        const countCheckInData = data.count_check_in_data
        const baseKey =
          wallPostBotData ||
          wallPostAgentData ||
          totalCaseBotData ||
          totalCaseAgentData ||
          inboxBotData ||
          inboxAgentData
        const json = []

        json.push(['Productivity Non-voice'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT)}`
        ])

        const {
          row: secondHeaderRow,
          wallPostBotCellRange,
          inboxBotCellRange,
          inboxAgentCellRange,
          incomingTxnBotCellRange,
          incomingTxnAgentCellRange
        } = (() => {
          const row = [
            'Date',
            ...Array(5)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Wall post (Bot)'
                return value
              }),
            ...Array(5)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Wall post (Agent)'
                return value
              }),
            ...Array(5)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Inbox (Bot)'
                return value
              }),
            ...Array(5)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Inbox (Agent)'
                return value
              }),
            ...Array(6)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Incoming Txn Bot (Total cases)'
                return value
              }),
            ...Array(6)
              .fill('')
              .map((value, index) => {
                if (index === 0) return 'Incoming Txn Agent (Total cases)'
                return value
              }),
            'Total Agent intraday'
          ]

          return {
            row: row,
            wallPostBotCellRange: {
              s: { r: 2, c: 1 },
              e: { r: 2, c: 1 + 4 }
            },
            wallpostAgentCellRange: {
              s: { r: 2, c: 1 + 5 },
              e: { r: 2, c: 1 + 5 + 4 }
            },
            inboxBotCellRange: {
              s: { r: 2, c: 1 + 10 },
              e: { r: 2, c: 1 + 10 + 4 }
            },
            inboxAgentCellRange: {
              s: { r: 2, c: 1 + 15 },
              e: { r: 2, c: 1 + 15 + 4 }
            },
            incomingTxnBotCellRange: {
              s: { r: 2, c: 1 + 20 },
              e: { r: 2, c: 1 + 20 + 5 }
            },
            incomingTxnAgentCellRange: {
              s: { r: 2, c: 1 + 26 },
              e: { r: 2, c: 1 + 26 + 5 }
            }
          }
        })()

        json.push(secondHeaderRow)
        json.push([
          '',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'AHT (hh:mm:ss)',
          'Within 30 Mins',
          '30-60 Mins',
          'Over 60 Mins',
          'Volume',
          '% SL (W/I 30 mins)',
          'AHT (hh:mm:ss)',
          ''
        ])

        let sumWallPostBotColumn = [0, 0, 0, 0, 0],
          sumWallPostAgentColumn = [0, 0, 0, 0, 0],
          sumInboxBotColumn = [0, 0, 0, 0, 0],
          sumInboxAgentColumn = [0, 0, 0, 0, 0],
          sumTotalCaseBotColumn = [0, 0, 0, 0, 0, 0, 0],
          sumTotalCaseAgentColumn = [0, 0, 0, 0, 0, 0, 0],
          sumCountCheckInData = [0]

        let sumTotalSla = 0

        for (const key in baseKey) {
          let wallPostBotColumn = [],
            wallPostAgentColumn = [],
            inboxBotColumn = [],
            inboxAgentColumn = [],
            totalCaseBotColumn = [],
            totalCaseAgentColumn = [],
            countCheckInColumn = []
          if (wallPostBotData && Object.hasOwnProperty.call(wallPostBotData, key)) {
            const element = wallPostBotData[key]
            wallPostBotColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent
            ]

            sumWallPostBotColumn = [
              sumWallPostBotColumn[0] + element.within_thirty_minutes,
              sumWallPostBotColumn[1] + element.between_thirty_to_sixty_minutes,
              sumWallPostBotColumn[2] + element.over_sixty_minutes,
              sumWallPostBotColumn[3] + element.volume,
              0
            ]
          } else {
            wallPostBotColumn = ['0', '0', '0', '0', '0']
          }

          if (wallPostAgentData && Object.hasOwnProperty.call(wallPostAgentData, key)) {
            const element = wallPostAgentData[key]
            wallPostAgentColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent
            ]

            sumWallPostAgentColumn = [
              sumWallPostAgentColumn[0] + element.within_thirty_minutes,
              sumWallPostAgentColumn[1] + element.between_thirty_to_sixty_minutes,
              sumWallPostAgentColumn[2] + element.over_sixty_minutes,
              sumWallPostAgentColumn[3] + element.volume,
              0
            ]
          } else {
            wallPostAgentColumn = ['0', '0', '0', '0', '0']
          }

          if (inboxBotData && Object.hasOwnProperty.call(inboxBotData, key)) {
            const element = inboxBotData[key]
            inboxBotColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent
            ]

            sumInboxBotColumn = [
              sumInboxBotColumn[0] + element.within_thirty_minutes,
              sumInboxBotColumn[1] + element.between_thirty_to_sixty_minutes,
              sumInboxBotColumn[2] + element.over_sixty_minutes,
              sumInboxBotColumn[3] + element.volume,
              0
            ]
          } else {
            inboxBotColumn = ['0', '0', '0', '0', '0']
          }

          if (inboxAgentData && Object.hasOwnProperty.call(inboxAgentData, key)) {
            const element = inboxAgentData[key]
            inboxAgentColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent
            ]

            sumInboxAgentColumn = [
              sumInboxAgentColumn[0] + element.within_thirty_minutes,
              sumInboxAgentColumn[1] + element.between_thirty_to_sixty_minutes,
              sumInboxAgentColumn[2] + element.over_sixty_minutes,
              sumInboxAgentColumn[3] + element.volume,
              0
            ]
          } else {
            inboxAgentColumn = ['0', '0', '0', '0', '0']
          }

          if (totalCaseBotData && Object.hasOwnProperty.call(totalCaseBotData, key)) {
            const element = totalCaseBotData[key]
            totalCaseBotColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent,
              this.transformDurationTime(element.average_aht)
            ]

            sumTotalCaseBotColumn = [
              sumTotalCaseBotColumn[0] + element.within_thirty_minutes,
              sumTotalCaseBotColumn[1] + element.between_thirty_to_sixty_minutes,
              sumTotalCaseBotColumn[2] + element.over_sixty_minutes,
              sumTotalCaseBotColumn[3] + element.volume,
              0,
              sumTotalCaseBotColumn[5] + element.average_aht
            ]

            sumTotalSla = sumTotalSla + element.sl_percent
          } else {
            totalCaseBotColumn = ['0', '0', '0', '0', '0', '0', '0']
          }

          if (totalCaseAgentData && Object.hasOwnProperty.call(totalCaseAgentData, key)) {
            const element = totalCaseAgentData[key]
            totalCaseAgentColumn = [
              element.within_thirty_minutes,
              element.between_thirty_to_sixty_minutes,
              element.over_sixty_minutes,
              element.volume,
              element.sl_percent,
              this.transformDurationTime(element.average_aht)
            ]

            sumTotalCaseAgentColumn = [
              sumTotalCaseAgentColumn[0] + element.within_thirty_minutes,
              sumTotalCaseAgentColumn[1] + element.between_thirty_to_sixty_minutes,
              sumTotalCaseAgentColumn[2] + element.over_sixty_minutes,
              sumTotalCaseAgentColumn[3] + element.volume,
              0,
              sumTotalCaseAgentColumn[5] + element.average_aht
            ]

            sumTotalSla = sumTotalSla + element.sl_percent
          } else {
            totalCaseAgentColumn = ['0', '0', '0', '0', '0', '0', '0']
          }

          if (countCheckInData && Object.hasOwnProperty.call(countCheckInData, key)) {
            const element = countCheckInData[key]
            countCheckInColumn = [element]
            sumCountCheckInData[0] += parseInt(element)
          } else {
            countCheckInColumn = ['0']
          }

          json.push([
            dayjs(key).format(DATETIME.DATE_FORMAT_DISPLAY),
            ...wallPostBotColumn,
            ...wallPostAgentColumn,
            ...inboxBotColumn,
            ...inboxAgentColumn,
            ...totalCaseBotColumn,
            ...totalCaseAgentColumn,
            ...countCheckInColumn
          ])
        }

        sumWallPostBotColumn[4] = this.handlePercentage(
          sumWallPostBotColumn[0],
          sumWallPostBotColumn[3]
        )

        sumWallPostAgentColumn[4] = this.handlePercentage(
          sumWallPostAgentColumn[0],
          sumWallPostAgentColumn[3]
        )

        sumInboxBotColumn[4] = this.handlePercentage(sumInboxBotColumn[0], sumInboxBotColumn[3])

        sumInboxAgentColumn[4] = this.handlePercentage(
          sumInboxAgentColumn[0],
          sumInboxAgentColumn[3]
        )

        sumTotalCaseBotColumn[4] = this.handlePercentage(
          sumTotalCaseBotColumn[0],
          sumTotalCaseBotColumn[3]
        )
        sumTotalCaseBotColumn[5] = this.transformDurationTime(
          sumTotalCaseBotColumn[5] / Object.keys(baseKey).length
        )

        sumTotalCaseAgentColumn[4] = this.handlePercentage(
          sumTotalCaseAgentColumn[0],
          sumTotalCaseAgentColumn[3]
        )
        sumTotalCaseAgentColumn[5] = this.transformDurationTime(
          sumTotalCaseAgentColumn[5] / Object.keys(baseKey).length
        )

        sumCountCheckInData[0] = (sumCountCheckInData[0] / Object.keys(baseKey).length).toFixed(2)

        json.push([])
        json.push([
          '',
          ...sumWallPostBotColumn,
          ...sumWallPostAgentColumn,
          ...sumInboxBotColumn,
          ...sumInboxAgentColumn,
          ...sumTotalCaseBotColumn,
          ...sumTotalCaseAgentColumn,
          ...sumCountCheckInData
        ])
        const totalCaseLength =
          (Number(Object.keys(totalCaseBotData).length || 0) +
            Number(Object.keys(totalCaseAgentData).length || 0)) /
          2
        json.push([
          ...Array(21).fill(''),
          'Grand Total Incoming Txn',
          totalCaseLength ? `${sumTotalSla / totalCaseLength}%` : 0
        ])

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 2, c: 0 },
              e: { r: 3, c: 0 }
            },
            wallPostBotCellRange,
            inboxBotCellRange,
            inboxAgentCellRange,
            incomingTxnBotCellRange,
            incomingTxnAgentCellRange,
            {
              s: { r: 2, c: incomingTxnAgentCellRange.e.c + 1 },
              e: { r: 3, c: incomingTxnAgentCellRange.e.c + 1 }
            }
          ])
          .save('productivity-report')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportProductivityByIntervalReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        const allData = responseData.data
        const json = []
        json.push(['Productivity by Interval: Post'])
        json.push(['Channel', 'Post/Inbox message/all'])
        json.push(['', '', '', '', 'Serviced beyond SL', '', ''])
        json.push([
          'Date (DD/MM/YY)',
          'Interval',
          'Incoming Txn (Total cases)',
          'Total Agent (Log in skill Social)',
          'within 30 mins',
          '31-60 Mins',
          '> 60 Mins',
          '%SL',
          'AHT (hh:mm:ss)'
        ])

        Object.keys(allData).forEach((date) => {
          const dateValue = dayjs(date).format(DATETIME.DATE_FORMAT_DISPLAY)
          const hours = allData[date].hours

          Object.keys(hours).forEach((item) => {
            const hoursValue = `${item}:00:00`
            const itemValue = hours[item]
            json.push([
              dateValue,
              hoursValue,
              itemValue.incoming_total_case,
              itemValue.total_agent,
              itemValue.within_thirty_minutes,
              itemValue.between_thirty_to_sixty_minutes,
              itemValue.over_sixty_minutes,
              `${itemValue.sl_percent}%`,
              this.transformDurationTime(itemValue.aht)
            ])
          })
        })

        const mergeArr = Object.values(allData)
          .map((item) => Object.values(item.hours))
          .flat()
        const totalIncomingTotalCase = mergeArr.reduce((a, c) => a + c.incoming_total_case || 0, 0)
        const totalAgent = mergeArr.reduce((a, c) => a + c.total_agent, 0)
        const totalWithinThirtyMinutes = mergeArr.reduce((a, c) => a + c.within_thirty_minutes, 0)
        const totalBetweenThirtyToSixtyMinutes = mergeArr.reduce(
          (a, c) => a + c.between_thirty_to_sixty_minutes,
          0
        )
        const totalOverSixtyMinutes = mergeArr.reduce((a, c) => a + c.over_sixty_minutes, 0)
        const totalSlPercent = mergeArr.reduce((a, c) => a + c.sl_percent, 0)
        const totalAht = mergeArr.reduce((a, c) => a + c.aht, 0)

        json.push([])
        json.push([
          'Total',
          '',
          totalIncomingTotalCase,
          totalAgent,
          totalWithinThirtyMinutes,
          totalBetweenThirtyToSixtyMinutes,
          totalOverSixtyMinutes,
          (totalSlPercent / mergeArr.length).toFixed(2) + '%',
          this.transformDurationTime(totalAht / mergeArr.length)
        ])

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 2, c: 4 },
              e: { r: 2, c: 6 }
            }
          ])
          .save('report-productivity-by-interval')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    secondsToMinutesAndSeconds(seconds) {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60

      // Ensure that both minutes and seconds have two digits
      const formattedMinutes = String(minutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')

      return `${formattedMinutes}:${formattedSeconds}`
    },
    async exportSummaryStaffPerformanceReport(responseData, payload) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        let addOnData = []

        try {
          const addOnResponse = await ttbApi.getReportTransectionByAgent({
            params: payload
          })
          addOnData = addOnResponse.data.data
        } catch (error) {
          addOnData = []
        }

        const allData = responseData.data

        const result = allData.reduce((acc, item) => {
          const { assignadminid, platform_type } = item
          const key = assignadminid

          if (!acc[key]) {
            acc[key] = {
              within_thirty_minutes_inbox: 0,
              within_thirty_minutes_page: 0,
              between_thirty_to_sixty_minutes_inbox: 0,
              between_thirty_to_sixty_minutes_page: 0,
              over_sixty_minutes_inbox: 0,
              over_sixty_minutes_page: 0,
              sum_aht_inbox: 0,
              sum_aht_page: 0,
              number_case_offered_inbox: 0,
              number_case_offered_page: 0,
              number_case_answered_inbox: 0,
              number_case_answered_page: 0,
              aht_inbox: 0,
              aht_page: 0,
              aht_format_inbox: '00:00:00',
              aht_format_page: '00:00:00',
              sl_percent_inbox: 0,
              sl_percent_page: 0
            }
          }

          const platformSuffix = platform_type === 'inbox' ? '_inbox' : '_page'

          acc[key][`within_thirty_minutes${platformSuffix}`] += item.within_thirty_minutes
          acc[key][`between_thirty_to_sixty_minutes${platformSuffix}`] +=
            item.between_thirty_to_sixty_minutes
          acc[key][`over_sixty_minutes${platformSuffix}`] += item.over_sixty_minutes
          acc[key][`sum_aht${platformSuffix}`] += item.sum_aht
          acc[key][`number_case_offered${platformSuffix}`] += item.number_case_offered
          acc[key][`number_case_answered${platformSuffix}`] += item.number_case_answered
          acc[key][`aht${platformSuffix}`] = item.aht
          acc[key][`aht_format${platformSuffix}`] = item.aht_format
          acc[key][`sl_percent${platformSuffix}`] = item.sl_percent

          return acc
        }, {})

        const json = []
        json.push([`Sample: Summary all staff`, '', '', '', '', '', '', ''])
        json.push([
          `Date ${dayjs(this.selectedDate.start).format('DD/MM/YYYY')} - ${dayjs(
            this.selectedDate.end
          ).format('DD/MM/YYYY')}`,
          '',
          '',
          'Total',
          '',
          '',
          'ATH (hh:mm:ss)',
          '%SL'
        ])
        json.push([
          'Agent',
          'Number case offered',
          'Number case answered',
          'within 30 mins',
          '31-60 Mins',
          '> 60 Mins',
          'Inbox',
          'Inbox',
          'Post',
          'Transection'
        ])

        let sumData = {
          number_case_offered: 0,
          number_case_answered: 0,
          within_thirty_minutes: 0,
          between_thirty_to_sixty_minutes: 0,
          over_sixty_minutes: 0,
          aht: 0,
          transection: 0,
          number_case_offered_inbox: 0,
          number_case_offered_page: 0,
          within_thirty_minutes_inbox: 0,
          within_thirty_minutes_page: 0
        }

        let addOnMatchData = []
        let addOnNotMatchData = []
        for (let i = 0; i < addOnData.length; i++) {
          const data = addOnData[i]
          if (Object.keys(result).includes(addOnData[i].adminid)) {
            addOnMatchData.push(data)
          } else {
            addOnNotMatchData.push(data)
          }
        }
        Object.keys(result).forEach((adminId) => {
          const transectionData = addOnMatchData.find(
            (transection) => transection.adminid === adminId
          )
          let transectionCount = 0
          if (transectionData && transectionData.count) {
            transectionCount = transectionData.count
            sumData.transection += transectionCount
          }
          const adminIdValue = adminId
          const itemValue = result[adminId]
          const numberCaseOffered =
            itemValue.number_case_offered_inbox + itemValue.number_case_offered_page
          const numberCaseAnswered =
            itemValue.number_case_answered_inbox + itemValue.number_case_answered_page
          const numberWithinThirtyMinutes =
            itemValue.within_thirty_minutes_inbox + itemValue.within_thirty_minutes_page
          const betweenThirtyToSixtyMinutes =
            itemValue.between_thirty_to_sixty_minutes_inbox +
            itemValue.between_thirty_to_sixty_minutes_page
          const overSixtyMinutes =
            itemValue.over_sixty_minutes_inbox + itemValue.over_sixty_minutes_page

          const sumAht = itemValue.sum_aht_inbox + itemValue.sum_aht_page

          const aht = sumAht <= 0 || numberCaseAnswered <= 0 ? 0 : sumAht / numberCaseAnswered

          json.push([
            adminIdValue,
            numberCaseOffered,
            numberCaseAnswered,
            numberWithinThirtyMinutes,
            betweenThirtyToSixtyMinutes,
            overSixtyMinutes,
            this.transformDurationTime(Number(aht)),
            `${itemValue.sl_percent_inbox}%`,
            `${itemValue.sl_percent_page}%`,
            transectionCount
          ])
          sumData.number_case_offered += numberCaseOffered
          sumData.number_case_answered += numberCaseAnswered
          sumData.within_thirty_minutes += numberWithinThirtyMinutes
          sumData.between_thirty_to_sixty_minutes += betweenThirtyToSixtyMinutes
          sumData.over_sixty_minutes += overSixtyMinutes
          sumData.aht += Number(aht)
          sumData.number_case_offered_inbox += itemValue.number_case_offered_inbox
          sumData.number_case_offered_page += itemValue.number_case_offered_page
          sumData.within_thirty_minutes_inbox += itemValue.within_thirty_minutes_inbox
          sumData.within_thirty_minutes_page += itemValue.within_thirty_minutes_page
          // itemValue.aht && sumData.aht.push(itemValue.aht)
        })

        addOnNotMatchData.forEach((transection) => {
          if (transection && transection.count) {
            const transectionCount = transection.count
            sumData.transection += transectionCount
            json.push([
              transection.adminid,
              0,
              0,
              0,
              0,
              0,
              this.transformDurationTime(0),
              '0%',
              '0%',
              transectionCount
            ])
          }
        })

        if (this.selectedChatType === 'all') {
          let sl_percent_inbox = 0
          let sl_percent_page = 0
          try {
            let tempDataInBox =
              sumData.within_thirty_minutes_inbox / sumData.number_case_offered_inbox
            sl_percent_inbox = (tempDataInBox * 100).toFixed(2)
          } catch (error) {
            sl_percent_inbox = 0
          }
          try {
            let tempDataInPage =
              sumData.within_thirty_minutes_page / sumData.number_case_offered_page
            sl_percent_page = (tempDataInPage * 100).toFixed(2)
          } catch (error) {
            sl_percent_page = 0
          }
          json.push([
            'Total',
            sumData.number_case_offered,
            sumData.number_case_answered,
            sumData.within_thirty_minutes,
            sumData.between_thirty_to_sixty_minutes,
            sumData.over_sixty_minutes,
            this.transformDurationTime(sumData.aht),
            `${sl_percent_inbox}%`,
            `${sl_percent_page}%`,
            sumData.transection
          ])
        }

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 0, c: 0 },
              e: { r: 0, c: 7 }
            },
            {
              s: { r: 1, c: 0 },
              e: { r: 1, c: 2 }
            },
            {
              s: { r: 1, c: 3 },
              e: { r: 1, c: 5 }
            },
            {
              s: { r: 1, c: 7 },
              e: { r: 1, c: 8 }
            }
          ])
          .save('report-summary-staff-performance')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportPerformanceNonvoiceReport(data) {
      try {
        if (data === null || data.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        const performanceNonVoiceData = data.data

        const json = []

        json.push(['Performance Non-voice'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT)}`
        ])
        const yearData = []
        const monthKey = [
          'jan',
          'feb',
          'mar',
          'apr',
          'may',
          'jun',
          'jul',
          'aug',
          'sep',
          'oct',
          'nov',
          'dec',
          'ytd'
        ]
        for (const key in performanceNonVoiceData) {
          if (Object.hasOwnProperty.call(performanceNonVoiceData, key)) {
            const element = performanceNonVoiceData[key]
            yearData.push({
              key: key,
              list: Object.keys(element)
                .map((key) => ({ key: key.toUpperCase(), ...element[key] }))
                .sort((a, b) => {
                  if (monthKey.indexOf(a.key.toLowerCase()) > monthKey.indexOf(b.key.toLowerCase()))
                    return 1
                  if (monthKey.indexOf(a.key.toLowerCase()) < monthKey.indexOf(b.key.toLowerCase()))
                    return -1
                  return 0
                })
            })
          }
        }

        const { row: secondHeaderRow, yearCellRange } = (() => {
          const row = [
            'Topic',
            'Target',
            ...yearData
              .map((item) =>
                Array(item.list.length)
                  .fill('')
                  .map((value, index) => {
                    if (index === 0) return item.key
                    return value
                  })
              )
              .flat()
          ]

          return {
            row: row,
            yearCellRange: yearData.reduce((prev, curr) => {
              if (prev.length) {
                prev = [
                  ...prev,
                  {
                    s: { r: 2, c: 2 + prev[prev.length - 1].e.c - prev[prev.length - 1].s.c + 1 },
                    e: {
                      r: 2,
                      c:
                        2 +
                        prev[prev.length - 1].e.c -
                        prev[prev.length - 1].s.c +
                        1 +
                        curr.list.length -
                        1
                    }
                  }
                ]
              } else {
                prev = [
                  {
                    s: { r: 2, c: 2 },
                    e: { r: 2, c: 2 + curr.list.length - 1 }
                  }
                ]
              }
              return prev
            }, [])
          }
        })()

        json.push(secondHeaderRow)
        json.push(['', '', ...yearData.map((item) => item.list.map((item) => item.key)).flat()])

        const topics = [
          {
            text: 'SLA',
            valueKey: 'sla.percent',
            target: 90,
            type: 'percent'
          },
          { text: 'NPS', valueKey: 'nps.percent', target: 80, type: 'percent' },
          { text: 'OSAT Top box', valueKey: 'osat_top_box.percent', target: 85, type: 'percent' },
          {
            text: 'OSAT Top2box',
            valueKey: 'osat_top_two_boxes.percent',
            target: 95,
            type: 'percent'
          },
          { text: 'Number of Interviews', valueKey: 'number_of_interviews', type: 'number' },
          { text: 'Number of Response', valueKey: 'number_of_response', type: 'number' },
          { text: '%Response', valueKey: 'percent_of_response', type: 'percent' }
        ]

        topics.forEach((topic) => {
          const topicColumns = yearData
            .map((item) =>
              item.list.map(
                (item) => `${get(item, topic.valueKey)}${topic.type == 'percent' ? '%' : ''}`
              )
            )
            .flat()
          json.push([topic.text, topic.target || '', ...topicColumns])
        })

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 2, c: 0 },
              e: { r: 3, c: 0 }
            },
            {
              s: { r: 2, c: 1 },
              e: { r: 3, c: 1 }
            },
            ...yearCellRange.flat()
          ])
          .save('performenace-non-voice-report')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportClosedCaseByChannelReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const allData = responseData.data
        const json = []
        json.push(['Filter criteria:', 'Date duation, product'])
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push(['Channel:', this.selectedChannel])

        let channel = []
        if (this.selectedChannel === 'all') {
          channel = [
            'Facebook Inbox',
            'Facebook Post',
            'X Inbox',
            'X Post',
            'Pantip Inbox',
            'Pantip Post',
            'Total'
          ]
        }
        if (this.selectedChannel === 'facebook') {
          channel = ['Facebook Inbox', 'Facebook Post', 'Total']
        }
        // if (this.selectedChannel === 'line') {
        //   channel = ['line', 'total']
        // }
        if (this.selectedChannel === 'x') {
          channel = ['X Inbox', 'X Post', 'Total']
        }
        if (this.selectedChannel === 'pantip') {
          channel = ['Pantip Inbox', 'Pantip Post', 'Total']
        }

        json.push(['Date', ...channel])

        Object.keys(allData).forEach((date) => {
          const dateValue = dayjs(date).format(DATETIME.DATE_FORMAT_DISPLAY)
          const channelValue = allData[date].channel
          if (this.selectedChannel === 'all') {
            json.push([
              dateValue,
              channelValue.facebook_inbox || 0,
              channelValue.facebook_post || 0,
              channelValue.x_inbox || 0,
              channelValue.x_post || 0,
              channelValue.pantip_inbox || 0,
              channelValue.pantip_post || 0,
              channelValue.total || 0
            ])
          }
          if (this.selectedChannel === 'facebook') {
            json.push([
              dateValue,
              channelValue.facebook_inbox || 0,
              channelValue.facebook_post || 0,
              channelValue.total || 0
            ])
          }
          // if (this.selectedChannel === 'line') {
          //   json.push([dateValue, channelValue.line || 0, channelValue.total || 0])
          // }
          if (this.selectedChannel === 'x') {
            json.push([
              dateValue,
              channelValue.x_inbox || 0,
              channelValue.x_post || 0,
              channelValue.total || 0
            ])
          }
          if (this.selectedChannel === 'pantip') {
            json.push([
              dateValue,
              channelValue.pantip_inbox || 0,
              channelValue.pantip_post || 0,
              channelValue.total || 0
            ])
          }
        })

        const mergeArr = Object.values(allData)
          .map((item) => Object.values(item))
          .flat()
        const totalFacebookInbox = mergeArr.reduce((a, c) => a + c.facebook_inbox, 0)
        const totalFacebookPost = mergeArr.reduce((a, c) => a + c.facebook_post, 0)
        const totalXInbox = mergeArr.reduce((a, c) => a + c.x_inbox, 0)
        const totalXPost = mergeArr.reduce((a, c) => a + c.x_post, 0)
        const totalPantipInbox = mergeArr.reduce((a, c) => a + c.pantip_inbox, 0)
        const totalPantipPost = mergeArr.reduce((a, c) => a + c.pantip_post, 0)

        if (this.selectedChannel === 'all') {
          json.push([Array(8).fill('')])
          json.push([
            'Total',
            totalFacebookInbox,
            totalFacebookPost,
            totalXInbox,
            totalXPost,
            totalPantipInbox,
            totalPantipPost,
            totalFacebookInbox +
              totalFacebookPost +
              totalXInbox +
              totalXPost +
              totalPantipInbox +
              totalPantipPost
          ])
        }
        if (this.selectedChannel === 'facebook') {
          json.push([])
          json.push([
            'Total',
            totalFacebookInbox,
            totalFacebookPost,
            totalFacebookInbox + totalFacebookPost
          ])
        }
        if (this.selectedChannel === 'x') {
          json.push([])
          json.push(['Total', totalXInbox, totalXPost, totalXInbox + totalXPost])
        }
        if (this.selectedChannel === 'pantip') {
          json.push([])
          json.push([
            'Total',
            totalPantipInbox,
            totalPantipPost,
            totalPantipInbox + totalPantipPost
          ])
        }

        await this.generateExcel(json).save('report-closed-case-by-channel')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportSlByAgentByIntervalReport(data) {
      try {
        if (data === null || data.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }
        const slByAgentByIntervalData = data.data

        const json = []

        json.push(['SL by agent by interval report'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT)}`
        ])
        const slData = []

        for (const key in slByAgentByIntervalData) {
          if (Object.hasOwnProperty.call(slByAgentByIntervalData, key)) {
            const element = slByAgentByIntervalData[key]
            slData.push({
              key: key,
              ...element
            })
          }
        }

        json.push(['', '', '', '', 'Inbox message', '', '', 'Total', 'AHT (hh:mm:ss)'])
        json.push([
          'Date (DD/MM/YY)',
          'Interval',
          'Number case offered',
          'Number case answerd',
          'within 30 mins',
          '30-60 mins',
          '>60 mins',
          '',
          'Inbox'
        ])

        slData.forEach((data) => {
          for (const key in data.hours) {
            if (Object.hasOwnProperty.call(data.hours, key)) {
              const item = data.hours[key]
              json.push([
                dayjs(data.key).format(DATETIME.DATE_FORMAT_DISPLAY),
                `${key}:00:00`,
                item.number_case_offered,
                item.number_case_answered,
                item.within_thirty_minutes,
                item.between_thirty_to_sixty_minutes,
                item.over_sixty_minutes,
                item.within_thirty_minutes +
                  item.between_thirty_to_sixty_minutes +
                  item.over_sixty_minutes,
                this.transformDurationTime(item.aht)
              ])
            }
          }
        })

        const mergeArr = slData.map((item) => Object.values(item.hours)).flat()
        const totalNumberCaseOffered = mergeArr.reduce((a, c) => a + c.number_case_offered || 0, 0)
        const totalNumberCaseAnswered = mergeArr.reduce((a, c) => a + c.number_case_answered, 0)
        const totalWithinThirtyMinutes = mergeArr.reduce((a, c) => a + c.within_thirty_minutes, 0)
        const totalBetweenThirtyToSixtyMinutes = mergeArr.reduce(
          (a, c) => a + c.between_thirty_to_sixty_minutes,
          0
        )
        const totalOverSixtyMinutes = mergeArr.reduce((a, c) => a + c.over_sixty_minutes, 0)
        const totalAht = mergeArr.reduce((a, c) => a + c.aht, 0)

        json.push([])
        json.push([
          'Total',
          '',
          totalNumberCaseOffered,
          totalNumberCaseAnswered,
          totalWithinThirtyMinutes,
          totalBetweenThirtyToSixtyMinutes,
          totalOverSixtyMinutes,
          totalWithinThirtyMinutes + totalBetweenThirtyToSixtyMinutes + totalOverSixtyMinutes,
          this.transformDurationTime(totalAht / mergeArr.length)
        ])

        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 2, c: 7 },
              e: { r: 3, c: 7 }
            },
            {
              s: { r: 2, c: 4 },
              e: { r: 2, c: 6 }
            }
          ])
          .save('sl-by-agent-by-interval-report')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportCaseByStatusReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const allData = responseData.dataList
        const json = []
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push([
          'Status:',
          'Pending, Answered, Closed with Survey, Closed without Survey, Cancelled by Customer, Close by System'
        ])
        json.push([])
        json.push([
          'Date&Time',
          'Pending',
          'Answered',
          'Closed with Survey',
          'Closed without Survey',
          'Cancelled by Customer',
          'Close by System',
          'Total'
        ])
        allData.forEach((item) => {
          const allStatus = item.status

          const objValue = {}
          Object.values(allStatus).map((status) => {
            Object.assign(objValue, { ...status })
          })

          json.push([
            dayjs(item.date).format(DATETIME.DATE_FORMAT_DISPLAY),
            objValue.pending,
            objValue.answered,
            objValue.closed_with_survey,
            objValue.closed_without_survey,
            objValue.cancelled_by_customer,
            objValue.closed_by_system,
            objValue.total
          ])
        })

        json.push([])
        const mergeArr = allData
          .map((item) => item.status)
          .map((item) => {
            return Object.assign({}, ...item)
          })
        const totalPending = mergeArr.reduce((a, c) => a + c.pending, 0)
        const totalAnswered = mergeArr.reduce((a, c) => a + c.answered, 0)
        const totalCancelledByCustomer = mergeArr.reduce((a, c) => a + c.cancelled_by_customer, 0)
        const totalClosedBySystem = mergeArr.reduce((a, c) => a + c.closed_by_system, 0)
        const totalClosedWithSurvey = mergeArr.reduce((a, c) => a + c.closed_with_survey, 0)
        const totalClosedWithoutSurvey = mergeArr.reduce((a, c) => a + c.closed_without_survey, 0)
        const totalSummary = mergeArr.reduce((a, c) => a + c.total, 0)
        json.push([
          'Total',
          totalPending,
          totalAnswered,
          totalClosedWithSurvey,
          totalClosedWithoutSurvey,
          totalCancelledByCustomer,
          totalClosedBySystem,
          totalSummary
        ])

        await this.generateExcel(json).save('report-cased-by-status')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportCaseByProductReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const sumCountProduct = responseData.data.product

        const sortCountProduct = Object.fromEntries(
          Object.entries(sumCountProduct).sort((a, b) => b[1] - a[1])
        )

        const products = Object.keys(sortCountProduct)
        const countValueByProduct = Object.values(sortCountProduct)
        const total = countValueByProduct.reduce((prev, cur) => prev + cur)

        const json = []
        json.push(['Filter criteria', 'Date duration'])
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push([])
        json.push(['Date&Time', ...products, 'Total'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} - ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`,
          ...countValueByProduct,
          total
        ])

        json.push([])
        json.push([`Total`, ...countValueByProduct, total])

        await this.generateExcel(json).save('report-cased-by-products')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportClosedCaseByWrapUpReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const allData = responseData.data
        // const arrWrapUp = []

        // allData.forEach((item) => {
        //   if (item.wrap_up.length > 0) {
        //     arrWrapUp.push(...item.wrap_up)
        //   }
        // })

        // const sumCountSubject = arrWrapUp.reduce(
        //   (prev, cur) => ({
        //     ...prev,
        //     [cur.name]: (prev[cur.name] || 0) + cur.count
        //   }),
        //   {}
        // )

        // const sortCountSubject = Object.fromEntries(
        //   Object.entries(sumCountSubject)
        //     .sort((a, b) => b[1] - a[1])
        //     .slice(0, 10)
        // )

        // const subject = Object.keys(sortCountSubject)
        // const countValueBySubject = Object.values(sortCountSubject)
        // const total = countValueBySubject.reduce((prev, cur) => prev + cur)

        const json = []
        json.push(['Filter criteria', 'Date duration'])
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push([])
        json.push(['Date&Time', 'L1', 'L2', 'L3', 'L4'])
        // json.push([
        //   `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} - ${dayjs(
        //     this.selectedDate.end
        //   ).format(DATETIME.DATE_FORMAT_DISPLAY)}`,
        //   ...countValueBySubject,
        //   total
        // ])

        allData.forEach((item) => {
          json.push([
            dayjs(item.date_time).format(DATETIME.DATE_FORMAT_DISPLAY),
            ...Object.values(item.wrap_up).map((item) => item.name || '')
          ])
        })

        await this.generateExcel(json).save('report-closed-case-by-wrap-up')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportClosedCaseByWebpageReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const allPagesList = responseData.page
        const facebookPage = allPagesList
          .filter((item) => item.pageid)
          .map((item) => {
            return {
              name: item.pagename,
              channel: 'facebook',
              count: 0
            }
          })
        const xPage = allPagesList
          .filter((item) => item.x_channel_id)
          .map(() => {
            return {
              name: 'X',
              channel: 'x',
              count: 0
            }
          })

        const pantipPage = allPagesList
          .filter((item) => item.pantip_channel_id)
          .map(() => {
            return {
              name: 'Pantip',
              channel: 'pantip',
              count: 0
            }
          })

        const pageList =
          this.selectedChannel === 'all'
            ? [...facebookPage, ...xPage, ...pantipPage]
            : this.selectedChannel === 'x'
            ? xPage
            : pantipPage

        const allData = responseData.data
        const arrPages = []

        allData.forEach((item) => {
          if (item.page.length > 0) {
            const pages = item.page.filter((page) => page.name !== 'null' && page.name)
            arrPages.push(
              ...pages.map((item) => {
                if (['x', 'pantip'].includes(item.channel)) {
                  return {
                    ...item,
                    name: item.channel === 'x' ? 'X' : 'Pantip'
                  }
                }
                return item
              })
            )
          } else {
            arrPages.push(...pageList)
          }
        })

        const sumCountPage = arrPages.reduce(
          (prev, cur) => ({
            ...prev,
            [cur.name]: (prev[cur.name] || 0) + cur.count
          }),
          {}
        )

        let reorderedData = {
          ...Object.fromEntries(
            Object.entries(sumCountPage).filter(([key]) => key !== 'X' && key !== 'Pantip')
          ),
          X: sumCountPage.X,
          Pantip: sumCountPage.Pantip
        }

        if (this.selectedChannel === 'facebook') {
          delete reorderedData.X
          delete reorderedData.Pantip
        }
        if (this.selectedChannel === 'x') {
          reorderedData = {
            X: sumCountPage.X
          }
        }
        if (this.selectedChannel === 'pantip') {
          reorderedData = {
            Pantip: sumCountPage.Pantip
          }
        }

        const pages = Object.keys(reorderedData)
        const countValueByPage = Object.values(reorderedData)
        const sumAllPageValue = countValueByPage.reduce((prev, cur) => prev + cur)

        const json = []
        json.push(['Filter criteria', 'Date duration'])
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push([])
        json.push(['Date&Time', ...pages, 'Total'])
        json.push([
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} - ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`,
          ...countValueByPage,
          sumAllPageValue
        ])

        json.push([])

        json.push([`Total`, ...countValueByPage, sumAllPageValue])

        await this.generateExcel(json).save('report-closed-case-by-webpage')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportSurveyReport(responseData) {
      try {
        if (responseData === null || responseData.data === null) {
          this.$swal.fire('ไม่พบข้อมูล', 'ไม่สามารถ export ได้', 'warning')
          return
        }

        const allData = responseData.data
        const facebookData = allData.facebook

        const json = []
        json.push(['Filter criteria', 'Date duration'])
        json.push([
          'Date:',
          `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
            this.selectedDate.end
          ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
        ])
        json.push([])
        json.push(['', 'Facebook', ''])
        json.push(['NPS_GROUP', 'Number', 'Percent'])
        json.push([
          'ผู้สนับสนุน',
          facebookData.nps_group.supporter.count,
          `${facebookData.nps_group.supporter.percent}%`
        ])
        json.push([
          'ผู้เป็นกลาง',
          facebookData.nps_group.neutral.count,
          `${facebookData.nps_group.neutral.percent}%`
        ])
        json.push([
          'ผู้ไม่สนับสนุน',
          facebookData.nps_group.non_supporter.count,
          `${facebookData.nps_group.non_supporter.percent}%`
        ])
        json.push(['Number of Interviews', facebookData.nps_group.number_of_interviews, ''])
        json.push(['Number of Response', facebookData.nps_group.number_of_response, ''])
        json.push(['%Response', '', `${facebookData.nps_group.percent_of_response}%`])
        json.push([
          'NPS',
          facebookData.nps_group.nps_score,
          `${facebookData.nps_group.nps_percent}%`
        ])
        json.push(['OSAT_GROUP', '', ''])
        json.push([
          'ดีกว่าที่คิดไว้มาก',
          facebookData.osat_group.much_better_than_expected.count,
          `${facebookData.osat_group.much_better_than_expected.percent}%`
        ])
        json.push([
          'ดีกว่าที่คิดไว้',
          facebookData.osat_group.better_than_expected.count,
          `${facebookData.osat_group.better_than_expected.percent}%`
        ])
        json.push([
          'เฉยๆ',
          facebookData.osat_group.indifferent.count,
          `${facebookData.osat_group.indifferent.percent}%`
        ])
        json.push([
          'แย่กว่าที่คิด',
          facebookData.osat_group.worse_than_expected.count,
          `${facebookData.osat_group.worse_than_expected.percent}%`
        ])
        json.push([
          'แย่กว่าที่คิดมาก',
          facebookData.osat_group.much_worse_than_expected.count,
          `${facebookData.osat_group.much_worse_than_expected.percent}%`
        ])
        json.push(['Number of Interviews', facebookData.osat_group.number_of_interviews, ''])
        json.push(['Number of Response', facebookData.osat_group.number_of_response, ''])
        json.push(['%Response', '', `${facebookData.osat_group.percent_of_response}%`])
        json.push([
          'OSAT Top Box',
          facebookData.osat_group.osat_top_box.count,
          `${facebookData.osat_group.osat_top_box.percent}%`
        ])
        json.push([
          'OSAT Top 2 Boxes',
          facebookData.osat_group.osat_top_two_boxes.count,
          `${facebookData.osat_group.osat_top_two_boxes.percent}%`
        ])
        json.push([
          'Bottom 2 Boxes',
          facebookData.bottom_two_boxes.count,
          `${facebookData.bottom_two_boxes.percent}%`
        ])
        await this.generateExcel(json)
          .setWorksheetProperty('!merges', [
            {
              s: { r: 3, c: 1 },
              e: { r: 3, c: 2 }
            }
          ])
          .save('report-survey')
      } catch (error) {
        console.error(error)
        this.$swal.fire('เกิดข้อผิดพลาดของระบบ', 'ไม่สามารถ export ได้', 'error')
      }
    },
    async exportTransectionByAgentReport(responseData, payload) {
      const json = []

      // Base Report
      json.push(['Transection By Agent'])
      json.push([
        'Date:',
        `${dayjs(this.selectedDate.start).format(DATETIME.DATE_FORMAT_DISPLAY)} to ${dayjs(
          this.selectedDate.end
        ).format(DATETIME.DATE_FORMAT_DISPLAY)}`
      ])
      json.push(['Agent:', payload.admin_id || 'All'])
      json.push([])
      if (payload.admin_id) {
        // Data is group by time
        json.push(['Date', 'Interval', 'messages'])
        if (responseData && responseData.data && responseData.data.length) {
          let all = 0
          responseData.data.forEach((countMessageAgent) => {
            all += countMessageAgent.count
            const dateData = dayjs(countMessageAgent.date)
            json.push([
              dateData.format('DD/MM/YYYY'),
              dateData.format('HH:mm'),
              countMessageAgent.count || 0
            ])
          })
          json.push(['Total', '', all])
        } else {
          json.push(['Total', '', '0'])
        }
      } else {
        // Data is group by agent
        json.push(['Agent', 'message'])
        if (responseData && responseData.data && responseData.data.length) {
          let all = 0
          responseData.data.forEach((countMessageAgent) => {
            all += countMessageAgent.count
            json.push([countMessageAgent.adminid, countMessageAgent.count || 0])
          })
          json.push(['Total', all])
        } else {
          json.push(['Total', '0'])
        }
      }
      await this.generateExcel(json)
        .setWorksheetProperty('!merges', [
          {
            s: { r: 3, c: 1 },
            e: { r: 3, c: 2 }
          }
        ])
        .save('report-transection-by-agent')
    },
    handlePercentage(value, total) {
      value = typeof value === 'string' ? parseFloat(value) : value
      total = typeof total === 'string' ? parseFloat(total) : total
      if (value == 0 || total == 0) return '0%'
      return `${((value / total) * 100).toFixed(2)}%`
    },
    generateExcel(json) {
      function ExcelGenerator() {
        let _dataWS = XLSX.utils.aoa_to_sheet(json)

        this.setWorksheetProperty = (key, value) => {
          _dataWS[key] = value
          return this
        }

        this.save = (fileName) =>
          new Promise((resolve, reject) => {
            try {
              const wb = XLSX.utils.book_new()
              XLSX.utils.book_append_sheet(wb, _dataWS)
              XLSX.writeFile(wb, `${fileName}.xlsx`)
              resolve()
            } catch (error) {
              reject('Error: Generate excel failed')
            }
          })
      }

      return new ExcelGenerator()
    },
    transformDurationTime(value) {
      const hours = Math.floor(value / 60 / 60)
      const minutes = Math.floor(value / 60) % 60
      const seconds = Math.floor(value % 60)
      const padZero = (number) => (number > 99 ? number : number.toString().padStart(2, '0'))
      return `${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`
    },
    distributeRounding(numbers, targetSum) {
      let flooredNumbers = numbers.map(Math.floor) // ปัดเศษลงทั้งหมด
      let sum = flooredNumbers.reduce((a, b) => a + b, 0) // หาผลรวม
      if (sum <= 0) {
        return numbers
      }
      let remainders = numbers.map((num, index) => ({
        index: index,
        remainder: num - flooredNumbers[index]
      }))
      // เรียงลำดับจากค่าที่มีเศษทศนิยมมากที่สุดไปน้อยที่สุด
      remainders.sort((a, b) => b.remainder - a.remainder)
      // เพิ่มค่าทีละ 1 ให้กับตัวที่มีเศษทศนิยมสูงสุดจนกว่าจะถึง targetSum
      for (let i = 0; sum < targetSum; i++, sum++) {
        flooredNumbers[remainders[i].index] += 1
      }
      return flooredNumbers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Report/Export.vue